import Flex from "@/components/flex"
import { aptSelectBundle } from "../apt/apt-select-const"
import { langStore } from "@/stores/lang-store"

const SearchFilter = ({
  preview,
  keyword,
  setKeyword,
  isOpen,
  toggleOpen,
  placeholder,
  onSearch
}) => {
  const { lang } = langStore()
  return (
    <Flex className="flex-col md:flex-row" gap={16}>
      <button
        onClick={toggleOpen}
        className="w-full md:w-1/3 bg-white border border-slate-200 p-4 rounded-xl shadow-sm flex justify-between items-center text-slate-700 hover:border-blue-400 transition-colors"
      >
        <span className="font-medium truncate">{preview}</span>
        <span>{isOpen ? "▲" : "▼"}</span>
      </button>
      <div className="flex-1 relative w-full">
        <input
          className="bg-white border border-slate-200 p-4 w-full rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 transition-all"
          type="text"
          placeholder={placeholder}
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onSearch()}
        />
        <button
          onClick={onSearch}
          className="absolute right-3 top-3 bg-blue-600 text-white px-5 py-1.5 rounded-lg font-bold hover:bg-blue-700 transition-colors"
        >
          {aptSelectBundle.filter.searchButton[lang]}
        </button>
      </div>
    </Flex>
  )
}

export default SearchFilter
